import { CardMedia } from '@mui/material';

const LogoName = 'sageone.png';

const logoWidth = '75px';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="SageOne Logo"
      sx={{ width: logoWidth, mt: 1, ml: 2, pb: 1 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="SageOne Logo"
      sx={{ width: logoWidth, m: 2, my: 0.2 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="SageOne Logo"
      sx={{ width: logoWidth }}
    />
  );
};
